// Dashboard status tabs, in order: a tab's dashfilter is its position + 1
// (1 Active, 2 No-Show, 3 Telehealth, 4 Checked Out, 5 All). Shared by the
// tab bar (navigationmenu) and the dashboard's empty-state wording.
export const DASHBOARD_TABS = [
  { label: "Active", key: "active" },
  { label: "No-Show", key: "noshow" },
  { label: "Telehealth", key: "tele" },
  { label: "Checked Out", key: "checkedout" },
  // Every patient on the day's book, incl. No Show / Cancelled (dashfilter 5).
  // Must stay last.
  { label: "All", key: "all" },
];

// Label of the status tab for a dashfilter value ("" for none / unknown).
export const dashboardTabLabel = (dashfilter) =>
  DASHBOARD_TABS[Number(dashfilter) - 1]?.label || "";
